import React from "react";
import "./Hero.css";
import { Link } from "react-scroll";
import Imu from "../assets/imu2.png";

const Hero = () => (
  <div className="hero" id="home">
    <div className="hero-overlay">
      <div className="description">
        <h2 className="title">Hi , I am Sriragavi</h2>
        <h3 className="tagline">Eat -> Sleep -> Code -> Repeat</h3>
        <p className="paragraph">
          Hello! I am currently pursuing my education at Chennai Institute of
          Technology, where I have been excelling academically with a remarkable
          CGPA of 8.2 in the first four semesters. My major coursework focuses
          on essential subjects such as Operating Systems, Database Management
          Systems, Computer Networks, Object-Oriented Programming, Data
          Structures and Algorithms. Since beginning my educational journey in
          2021, I have been dedicated to expanding my knowledge and skills in
          the field of computer science. With an expected graduation year of
          2025, I am eager to leverage my education to contribute meaningfully
          to the world of technology and embark on exciting opportunities.
        </p>
        <div className="hero-btns">
          <button className="hire-me">
            <a
              href="https://drive.google.com/file/d/1oQwK5SEXOvvue2XDNYEz500tClrvFCaY/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Get My CV
            </a>
          </button>
          <button className="lets-talk">
            <Link spy smooth offset={50} duration={500} to="contact">
              Hire Me
            </Link>
          </button>
        </div>
      </div>
      <img src={Imu} alt="prantosh" className="hero-image" />
    </div>
    <div className="social-icons">
      <a href="https://github.com/sriragavip" target="_blank" rel="noreferrer">
        <i className="fa-brands fa-github" />
      </a>
      <a
        href="https://www.linkedin.com/in/sriragavi-p-b45384220/"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-linkedin-in" />
      </a>
      <div className="social-icons">
        <a href="https://linktr.ee/sriragavip" target="_blank" rel="noreferrer">
          <i className="fa fa-code" />
        </a>
      </div>
    </div>
  </div>
);

export default Hero;
